import React from 'react';
import { CobrancaForm } from '../components';

const CobrancaPage = ({ setCurrentView }) => {
  return (
    <div className="space-y-6">
      {/* Header da Página */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Nova Cobrança</h1>
            <p className="text-gray-600">
              Crie uma nova cobrança no sistema com todos os detalhes necessários
            </p>
          </div>
          <div className="flex items-center space-x-3">
            <button
              onClick={() => setCurrentView('search')}
              className="px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-colors"
            >
              ← Voltar às Consultas
            </button>
          </div>
        </div>
      </div>
      
      {/* Conteúdo da Página */}
      <CobrancaForm 
        setCurrentView={setCurrentView} 
        isInline={true}
      />
    </div>
  );
};

export default CobrancaPage;

